import angular from 'angular';
import moment from 'moment';
import { compactRelation } from '../../common/Filters/relationNameFilter';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import { getFirstSelectedInvoiceStreamId } from '@/shared/components/registration/registrationHelpers';

angular.module('cxRelations').directive('relTaskScheduling', function() {
  return {
    restrict: 'E',
    template: require('./relTaskScheduling.html'),
    scope: {
      relation: '=',
      fieldId: '@id',
    },
    controllerAs: 'vm',
    bindToController: true,
    controller: [
      '$scope',
      '$http',
      '$q',
      'flySvc',
      'appUrls',
      'ModalService',
      '$filter',
      'dialogsSvc',
      'checkSecurity',
      'invoiceStreamNamesSvc',
      function(
        $scope,
        $http,
        $q,
        flySvc,
        appUrls,
        ModalService,
        $filter,
        dialogsSvc,
        checkSecurity,
        invoiceStreamNamesSvc,
      ) {
        var vm = this;
        vm.today = moment.utc().startOf('day');
        vm.items = null;
        vm.loading = false;
        vm.invoiceStreams = null;
        vm.datepickerOptions = {
          startingDay: 1,
        };
        vm.$onInit = function() {
          vm.relationName = compactRelation(vm.relation);
        };

        var streamsPromise = null;
        var loadInvoiceStreams = function(reload) {
          if (!reload && streamsPromise) return streamsPromise;
          streamsPromise = invoiceStreamNamesSvc.get(vm.relation.id).then(function(streams) {
            vm.invoiceStreams = streams;
            return streams;
          });
          return streamsPromise;
        };

        var mapTaskSchedule = function(item) {
          item.name = $filter('translateList')(item.template.id, 'tasktemplate');
          item.invoiceStream = (vm.invoiceStreams || []).find(x => x.id === item.invoiceStreamId);
          return item;
        };

        var loadTaskSchedules = function(reload) {
          if (!checkSecurity('TaskSchedules:r')) return;
          if (!reload && vm.items != null) return;
          vm.loading = true;
          vm.items = [];
          $q.all([
            loadInvoiceStreams(),
            $http.get(appUrls.tasks + '/Api/TaskSchedules?relationId=' + vm.relation.id),
          ]).then(function(results) {
            var response = results[1];
            vm.items = response.data.map(mapTaskSchedule).sort(dynamicSort('name'));
            vm.loading = false;
          });
        };

        $scope.$on('invoiceStreamsChanged', function(event, data) {
          if (!data || data.relationId !== vm.relation.id) return;
          loadInvoiceStreams(true).then(function() {
            (vm.items || []).forEach(function(item) {
              item.invoiceStream = (vm.invoiceStreams || []).find(
                x => x.id === item.invoiceStreamId,
              );
            });
          });
        });
        vm.showScheduleDate = function() {
          if (!vm.items || !vm.items.length) return false;
          return vm.items.some(x => x.periodicity.showScheduleDate && !!x.scheduleDate);
        };

        vm.add = function(isCommon) {
          const modalConfig = !!isCommon
            ? {
                template: require('../dialogs/addCommonTaskSchedulesDialog.html'),
                controller: 'AddCommonTaskSchedulesDialogCtrl',
              }
            : {
                template: require('../dialogs/addTaskScheduleDialog.html'),
                controller: 'AddTaskScheduleDialogCtrl',
              };

          ModalService.showModal({
            controllerAs: 'vm',
            locationChangeSuccess: false,
            inputs: {
              streamId: getFirstSelectedInvoiceStreamId(
                vm.invoiceStreams,
                vm.relation.invoiceStreamId,
              ),
              invoiceStreams: vm.invoiceStreams || [],
              relationId: vm.relation.id,
              isCommon: !!isCommon,
              relType: vm.relation.type,
              existingSchedules: vm.items,
            },
            ...modalConfig,
          }).then(function(modal) {
            modal.element.modal();
            modal.close.then(function(result) {
              if (typeof result === 'undefined' || result === null) return false;

              for (var i = 0; i < result.length; i++) {
                if (result[i] === null) continue;
                var item = mapTaskSchedule(result[i]);
                vm.items.push(item);
                vm.planNow(item); //Automatically plan the first task in the schedule
              }

              return true;
            });
            modal.element.on('hidden.bs.modal', function(e) {
              modal.element.off(e); //Remove event
              modal.element.remove(); //Remove element
            });
          });
        };
        vm.save = function(item, field, data) {
          if (typeof data === 'undefined') return '';
          if (angular.equals(item[field], data)) return false;
          var model = angular.copy(item);
          model[field] = data;
          if (!!model.planningStop && model.planningStop instanceof Date)
            model.planningStop = model.planningStop.ISO();
          return $http
            .post(appUrls.tasks + '/api/TaskSchedules/Update', model)
            .then(function(response) {
              angular.extend(item, mapTaskSchedule(response.data));
              flySvc.success('msgConfirmChange');
              return false;
            });
        };

        vm.remove = function(item) {
          if (item.removing) return;
          return dialogsSvc
            .showYesNoCancel('msgDeleteTaskSchedule', 'msgDeleteTaskScheduleAlsoDeletePlannedTasks')
            .then(
              function(result) {
                if (result === null) return false; //Cancelled
                item.removing = true;
                $http
                  .delete(
                    appUrls.tasks +
                      '/api/TaskSchedules/?id=' +
                      item.id +
                      '&deletePlannedTasks=' +
                      result,
                  )
                  .then(
                    function() {
                      var idx = vm.items.indexOf(item);
                      if (idx >= 0) vm.items.splice(idx, 1);
                      flySvc.success('msgItemRemoved');
                    },
                    function(error) {
                      flySvc.error(error);
                      item.removing = false;
                    },
                  );
                return true;
              },
              function() {
                return false;
              },
            );
        };

        vm.planNow = function(item) {
          if (item.planningNow || item.removing) return;
          item.planningNow = true;
          $http
            .post(appUrls.tasks + '/api/TaskSchedules/Plan/' + item.id)
            .then(
              function(response) {
                if (response && response.data)
                  var name =
                    response.data.name ||
                    $filter('translateList')(response.data.templateId, 'tasktemplate');
                flySvc.success('msgTaskPlannedOn', {
                  name: name,
                  deadline: $filter('date')(response.data.deadline, 'dd-MM-yyyy'),
                });
              },
              function(error) {
                flySvc.error(error);
              },
            )
            .finally(() => {
              item.planningNow = false;
            });
        };

        vm.editDeviations = function(item) {
          ModalService.showModal({
            template: require('../dialogs/taskScheduleDeviationsDialog.html'),
            controller: 'TaskScheduleDeviationsDialogCtrl',
            controllerAs: 'vm',
            locationChangeSuccess: false,
            inputs: {
              schedule: item,
            },
          }).then(function(modal) {
            modal.element.modal();
            modal.close.then(saved => {
              if (saved) vm.reloadPlannedDuration(item);
            });
            modal.element.on('hidden.bs.modal', function(e) {
              modal.element.off(e); //Remove event
              modal.element.remove(); //Remove element
            });
          });
        };

        // Duration deviations are edited in a separate dialog, so refetch the resulting total
        vm.reloadPlannedDuration = item => {
          if (item.plannedDurationPerYear === null) return null;
          return $http.get(`${appUrls.tasks}/api/TaskSchedules/${item.id}/PlannedDuration`).then(
            response => {
              item.plannedDurationPerYear = response.data.minutes;
            },
            error => {
              flySvc.error(error);
            },
          );
        };

        vm.showPlanning = function(item) {
          ModalService.showModal({
            template: require('../dialogs/plannedTasksDialog.html'),
            controller: 'PlannedTasksDialogCtrl',
            controllerAs: 'vm',
            locationChangeSuccess: false,
            inputs: {
              schedule: item,
            },
          }).then(function(modal) {
            modal.element.modal();
            modal.element.on('hidden.bs.modal', function(e) {
              modal.element.off(e); //Remove event
              modal.element.remove(); //Remove element
            });
          });
        };

        vm.changeAssignment = function(item, newInvoiceStream) {
          if (!newInvoiceStream || !newInvoiceStream.id) return '';
          if (item.invoiceStreamId === newInvoiceStream.id) return false;
          ModalService.showModal({
            template: require('../dialogs/taskScheduleChangeAssignmentDialog.html'),
            controller: 'TaskScheduleChangeAssignmentDialogCtrl',
            controllerAs: 'vm',
            locationChangeSuccess: false,
            inputs: {
              schedule: item,
              invoiceStreamId: newInvoiceStream.id,
            },
          }).then(function(modal) {
            modal.element.modal();
            modal.close.then(function(result) {
              if (!result) return; //Cancelled
              angular.extend(item, mapTaskSchedule(result));
              flySvc.success('msgConfirmChange');
            });
            modal.element.on('hidden.bs.modal', function(e) {
              modal.element.off(e); //Remove event
              modal.element.remove(); //Remove element
            });
          });

          return false; //Tell xEditable we will update the model
        };

        vm.toggleCollapsed = function(collapsed) {
          if (!collapsed) loadTaskSchedules();
        };

        vm.editRemark = function(item) {
          ModalService.showModal({
            template: require('../dialogs/editTaskScheduleRemarkDialog.html'),
            controller: 'EditTaskScheduleRemarkDialogCtrl',
            controllerAs: 'vm',
            locationChangeSuccess: false,
            inputs: {
              taskScheduleId: item.id,
              value: item.remark,
            },
          }).then(function(modal) {
            modal.element.modal();
            modal.close.then(function(result) {
              if (!result) return; //Cancelled

              const { value = '' } = result;
              item.remark = value;

              flySvc.success('msgConfirmChange');
            });
            modal.element.on('hidden.bs.modal', function(e) {
              modal.element.off(e); //Remove event
              modal.element.remove(); //Remove element
            });
          });
        };
      },
    ],
  };
});
